/*
 * Module for the Authoring Rules area of modal
 */

define([
  "marionette",
  "jquery",
  "underscore",
  "backbone",
  "messaging/messenger",
  "./authoringRulesView",
  "modules/accountAdmin/privilegeEnum",
  "modules/accountAdmin/kbRoleAdmin/kbRoleModel",
], function (
  Marionette,
  $,
  _,
  Backbone,
  Messenger,
  AuthoringRulesView,
  PrivilegeEnum,
  KbRoleModel,
) {
  var AuthoringRulesController = Marionette.Controller.extend({
    initialize: function (options) {
      this.region = options.region;
      this.name = "authoringRulesModule";
    },
    show: function (kbRole) {
      this.kbRole = kbRole;
      this._createModelFromRole();
      this.view = new AuthoringRulesView.authoringRulesView({ model: this.model });

      this.view.on(
        "click:allowEditTopicName",
        function () {
          this.model.set("allowEditTopicName", !this.model.get("allowEditTopicName"));
          this.view.render();
        },
        this,
      );

      this.view.on(
        "click:allowEditTopicStatus",
        function () {
          this.model.set("allowEditTopicStatus", !this.model.get("allowEditTopicStatus"));
          this.view.render();
        },
        this,
      );

      this.view.on(
        "click:allowEditTopicFolder",
        function () {
          this.model.set("allowEditTopicFolder", !this.model.get("allowEditTopicFolder"));
          this.view.render();
        },
        this,
      );

      this.view.on(
        "click:allowDeleteTopic",
        function () {
          this.model.set("allowDeleteTopic", !this.model.get("allowDeleteTopic"));
          this.view.render();
        },
        this,
      );

      this.view.on(
        "click:allowDeleteAll",
        function () {
          var deleteAll = !this.model.get("allowDeleteAll");
          this.model.set("allowDeleteAll", deleteAll);
          this.model.set("allowDeleteCategoryCodes", deleteAll);
          this.model.set("allowDeleteTopicExamples", deleteAll);
          this.view.render();
        },
        this,
      );

      this.view.on(
        "click:allowEditAll",
        function () {
          var editAll = !this.model.get("allowEditAll");
          this.model.set("allowEditAll", editAll);
          this.model.set("allowEditCategoryCodes", editAll);
          this.model.set("allowEditTopicExamples", editAll);
          this.model.set("allowEditTopicLabels", editAll);
          this.view.render();
        },
        this,
      );

      this.view.on(
        "click:allowViewAll",
        function () {
          var viewAll = !this.model.get("allowViewAll");
          this.model.set("allowViewAll", viewAll);
          this.model.set("allowViewCategoryCodes", viewAll);
          this.model.set("allowViewTopicExamples", viewAll);
          this.model.set("allowViewTopicLabels", viewAll);
          this.view.render();
        },
        this,
      );

      this.view.on(
        "click:allowDeleteCategoryCodes",
        function () {
          this.model.set("allowDeleteCategoryCodes", !this.model.get("allowDeleteCategoryCodes"));
          this.model.set("allowDeleteAll", false);
          this.view.render();
        },
        this,
      );

      this.view.on(
        "click:allowEditCategoryCodes",
        function () {
          this.model.set("allowEditCategoryCodes", !this.model.get("allowEditCategoryCodes"));
          this.model.set("allowEditAll", false);
          this.view.render();
        },
        this,
      );

      this.view.on(
        "click:allowViewCategoryCodes",
        function () {
          this.model.set("allowViewCategoryCodes", !this.model.get("allowViewCategoryCodes"));
          this.model.set("allowViewAll", false);
          this.view.render();
        },
        this,
      );

      this.view.on(
        "click:allowEditTopicExamples",
        function () {
          this.model.set("allowEditTopicExamples", !this.model.get("allowEditTopicExamples"));
          this.model.set("allowEditAll", false);
          this.view.render();
        },
        this,
      );

      this.view.on(
        "click:allowViewTopicExamples",
        function () {
          this.model.set("allowViewTopicExamples", !this.model.get("allowViewTopicExamples"));
          this.model.set("allowViewAll", false);
          this.view.render();
        },
        this,
      );

      this.view.on(
        "click:allowDeleteTopicExamples",
        function () {
          this.model.set("allowDeleteTopicExamples", !this.model.get("allowDeleteTopicExamples"));
          this.model.set("allowDeleteAll", false);
          this.view.render();
        },
        this,
      );

      this.view.on(
        "click:allowEditTopicLabels",
        function () {
          this.model.set("allowEditTopicLabels", !this.model.get("allowEditTopicLabels"));
          this.model.set("allowEditAll", false);
          this.view.render();
        },
        this,
      );

      this.view.on(
        "click:allowViewTopicLabels",
        function () {
          this.model.set("allowViewTopicLabels", !this.model.get("allowViewTopicLabels"));
          this.model.set("allowViewAll", false);
          this.view.render();
        },
        this,
      );

      this.showRegion(this.view);
    },
    _createModelFromRole: function () {
      this.model = new Backbone.Model({
        allowDeleteAll: false,
        allowDeleteCategoryCodes: false,
        allowDeleteTopic: false,
        allowDeleteTopicExamples: false,
        allowEditAll: false,
        allowEditCategoryCodes: false,
        allowEditTopicExamples: false,
        allowEditTopicFolder: false,
        allowEditTopicLabels: false,
        allowEditTopicName: false,
        allowEditTopicStatus: false,
        allowViewAll: false,
        allowViewCategoryCodes: false,
        allowViewTopicExamples: false,
        allowViewTopicLabels: false,
      });
      this.kbRole.privileges().each(function (privilege) {
        switch (privilege.get("privId")) {
          case PrivilegeEnum.TopicDeleteCategoryCodes:
            this.model.set("allowDeleteCategoryCodes", true);
            this.model.allowDeleteCategoryCodesPrivilege = privilege;
            break;
          case PrivilegeEnum.TopicDelete:
            this.model.set("allowDeleteTopic", true);
            this.model.allowDeleteTopicPrivilege = privilege;
            break;
          case PrivilegeEnum.TopicDeleteExamples:
            this.model.set("allowDeleteTopicExamples", true);
            this.model.allowDeleteTopicExamplesPrivilege = privilege;
            break;
          case PrivilegeEnum.TopicEditCategoryCodes:
            this.model.set("allowEditCategoryCodes", true);
            this.model.allowEditCategoryCodesPrivilege = privilege;
            break;
          case PrivilegeEnum.TopicEditExamples:
            this.model.set("allowEditTopicExamples", true);
            this.model.allowEditTopicExamplesPrivilege = privilege;
            break;
          case PrivilegeEnum.TopicEditFolder:
            this.model.set("allowEditTopicFolder", true);
            this.model.allowEditTopicFolderPrivilege = privilege;
            break;
          case PrivilegeEnum.TopicEditLabels:
            this.model.set("allowEditTopicLabels", true);
            this.model.allowEditTopicLabelsPrivilege = privilege;
            break;
          case PrivilegeEnum.TopicEditName:
            this.model.set("allowEditTopicName", true);
            this.model.allowEditTopicNamePrivilege = privilege;
            break;
          case PrivilegeEnum.TopicEditStatus:
            this.model.set("allowEditTopicStatus", true);
            this.model.allowEditTopicStatusPrivilege = privilege;
            break;
          case PrivilegeEnum.TopicViewCategoryCodes:
            this.model.set("allowViewCategoryCodes", true);
            this.model.allowViewCategoryCodesPrivilege = privilege;
            break;
          case PrivilegeEnum.TopicViewExamples:
            this.model.set("allowViewTopicExamples", true);
            this.model.allowViewTopicExamplesPrivilege = privilege;
            break;
          case PrivilegeEnum.TopicViewLabels:
            this.model.set("allowViewTopicLabels", true);
            this.model.allowViewTopicLabelsPrivilege = privilege;
            break;
        }
      }, this);
    },
    _createPrivilege: function (privId) {
      var privilege = new KbRoleModel.kbRolePrivilege({
        kbRoleId: this.kbRole.get("id"),
        privId: privId,
        privName: PrivilegeEnum.getPrivilegeName(privId),
      });
      return privilege;
    },
    getPrivileges: function () {
      var newPrivileges = [];
      var privilege;
      if (this.model.get("allowDeleteCategoryCodes")) {
        privilege = this.model.allowDeleteCategoryCodesPrivilege;
        if (!privilege) {
          privilege = this._createPrivilege(PrivilegeEnum.TopicDeleteCategoryCodes);
          this.model.allowDeleteCategoryCodesPrivilege = privilege;
        }
        newPrivileges.push(privilege);
      }
      if (this.model.get("allowDeleteTopic")) {
        privilege = this.model.allowDeleteTopicPrivilege;
        if (!privilege) {
          privilege = this._createPrivilege(PrivilegeEnum.TopicDelete);
          this.model.allowDeleteTopicPrivilege = privilege;
        }
        newPrivileges.push(privilege);
      }
      if (this.model.get("allowDeleteTopicExamples")) {
        privilege = this.model.allowDeleteTopicExamplesPrivilege;
        if (!privilege) {
          privilege = this._createPrivilege(PrivilegeEnum.TopicDeleteExamples);
          this.model.allowDeleteTopicExamplesPrivilege = privilege;
        }
        newPrivileges.push(privilege);
      }
      if (this.model.get("allowEditCategoryCodes")) {
        privilege = this.model.allowEditCategoryCodesPrivilege;
        if (!privilege) {
          privilege = this._createPrivilege(PrivilegeEnum.TopicEditCategoryCodes);
          this.model.allowEditCategoryCodesPrivilege = privilege;
        }
        newPrivileges.push(privilege);
      }
      if (this.model.get("allowEditTopicExamples")) {
        privilege = this.model.allowEditTopicExamplesPrivilege;
        if (!privilege) {
          privilege = this._createPrivilege(PrivilegeEnum.TopicEditExamples);
          this.model.allowEditTopicExamplesPrivilege = privilege;
        }
        newPrivileges.push(privilege);
      }
      if (this.model.get("allowEditTopicFolder")) {
        privilege = this.model.allowEditTopicFolderPrivilege;
        if (!privilege) {
          privilege = this._createPrivilege(PrivilegeEnum.TopicEditFolder);
          this.model.allowEditTopicFolderPrivilege = privilege;
        }
        newPrivileges.push(privilege);
      }
      if (this.model.get("allowEditTopicLabels")) {
        privilege = this.model.allowEditTopicLabelsPrivilege;
        if (!privilege) {
          privilege = this._createPrivilege(PrivilegeEnum.TopicEditLabels);
          this.model.allowEditTopicLabelsPrivilege = privilege;
        }
        newPrivileges.push(privilege);
      }
      if (this.model.get("allowEditTopicName")) {
        privilege = this.model.allowEditTopicNamePrivilege;
        if (!privilege) {
          privilege = this._createPrivilege(PrivilegeEnum.TopicEditName);
          this.model.allowEditTopicNamePrivilege = privilege;
        }
        newPrivileges.push(privilege);
      }
      if (this.model.get("allowEditTopicStatus")) {
        privilege = this.model.allowEditTopicStatusPrivilege;
        if (!privilege) {
          privilege = this._createPrivilege(PrivilegeEnum.TopicEditStatus);
          this.model.allowEditTopicStatusPrivilege = privilege;
        }
        newPrivileges.push(privilege);
      }
      if (this.model.get("allowViewCategoryCodes")) {
        privilege = this.model.allowViewCategoryCodesPrivilege;
        if (!privilege) {
          privilege = this._createPrivilege(PrivilegeEnum.TopicViewCategoryCodes);
          this.model.allowViewCategoryCodesPrivilege = privilege;
        }
        newPrivileges.push(privilege);
      }
      if (this.model.get("allowViewTopicExamples")) {
        privilege = this.model.allowViewTopicExamplesPrivilege;
        if (!privilege) {
          privilege = this._createPrivilege(PrivilegeEnum.TopicViewExamples);
          this.model.allowViewTopicExamplesPrivilege = privilege;
        }
        newPrivileges.push(privilege);
      }
      if (this.model.get("allowViewTopicLabels")) {
        privilege = this.model.allowViewTopicLabelsPrivilege;
        if (!privilege) {
          privilege = this._createPrivilege(PrivilegeEnum.TopicViewLabels);
          this.model.allowViewTopicLabelsPrivilege = privilege;
        }
        newPrivileges.push(privilege);
      }
      return newPrivileges;
    },
  });

  return AuthoringRulesController;
});
